import React from 'react';
import { PostResponseSchema } from '../../../../api/client';
import UserInfoOverlay from '../../components/UserInfoOverlay';

interface Props {
  post: PostResponseSchema;
}

export default function PostCardAudioPlayer({ post }: Props): React.ReactElement | null {
  if (!post.audio_url) {
    return null;
  }

  return (
    <div className="audio-wrapper">
      <audio src={post.audio_url} className="post-audio" controls>
        Your browser does not support the audio element.
      </audio>

      <UserInfoOverlay
        profilePic={post.profile_pic}
        username={post.username}
        timestamp={post.timestamp}
        variant="standard"
      />
    </div>
  );
}
